$(document).ready(function(){
      $(document).mouseup(function (e) {
        var container = $('.header-sidebar');
        if (!container.is(e.target) && container.has(e.target).length === 0 && $('.header-sidebar').hasClass('toggle')) {
        $('.header-sidebar').removeClass('toggle')
        $('.overlay-content').removeClass('overlay')
        $('body').removeClass('opened-drawer');
        }
    });
  
    $(document).on('click', '.nav-menu-icon', function() {
        $('.header-sidebar').toggleClass('toggle');
        $('body').toggleClass('opened-drawer');
        $('.overlay-content').toggleClass('overlay');
        $('.overlay-content').css('backdrop-filter', 'blur(2px)')
    });
    
    $(document).on('click', '.close-button .icon-close', function() {
        $('.header-sidebar').removeClass('toggle');
        $('body').removeClass('opened-drawer');
        $('.overlay-content').removeClass('overlay');
    });

      $(document).on('click','.accordian-label',function(event) {
        event.preventDefault();
        $('.accordion-icon').removeClass('active');
        if($(this).next().hasClass('show')) {
          $(this).next().removeClass('show');
          $(this).next().slideUp(450);
          $(this).find('.accordion-icon').removeClass('active');
        } else {
        $(this).parent().parent().find('.accordion-content').removeClass('show');
        $(this).parent().parent().find('.accordion-content').slideUp(450);
        $(this).next().toggleClass('show');
        $(this).next().slideToggle(450);
        $(this).find('.accordion-icon').addClass('active');
        }
    });

	$('.single-product-slider').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  prevArrow: ".main-arrow-prev",
      nextArrow: ".main-arrow-next",
	  fade: true,
	  asNavFor: '.product-thumbnail-slider'
	});
  
    $('.product-thumbnail-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical: true,
      asNavFor: '.single-product-slider',
      centerMode: false,
      focusOnSelect: true,
      prevArrow: ".thumb-prev",
      nextArrow: ".thumb-next",
      responsive: [
        {
          breakpoint: 750,
          settings: {
            vertical: false,
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 600,
          settings: {
            vertical: false,
            slidesToShow: 3,
          }
        }
      ]
    });

});